import { UserResponseModel } from '../../models/users/UserResponseModel';

export enum UserActionTypes {
  SET_USER_DETAILS = 'SET_USER_DETAILS',
}

export type UserActions = ISetUserDetailsAction;

export interface ISetUserDetailsAction {
  type: UserActionTypes.SET_USER_DETAILS;
  userDetails: UserResponseModel;
}

export const setUserDetailsAction: any = (
  userDetails: UserResponseModel,
): ISetUserDetailsAction => ({
  type: UserActionTypes.SET_USER_DETAILS,
  userDetails,
});
